import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import { Storage } from '@ionic/storage';
import { EmailComposer } from '@ionic-native/email-composer/ngx';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';

@Component({
  selector: 'app-vacante',
  templateUrl: './vacante.page.html',
  styleUrls: ['./vacante.page.scss', '../../assets/scss/styles.scss'],
})
export class VacantePage implements OnInit {

  public reparacionForm: FormGroup;

  constructor(
    public services: ServiceService,
    public storage: Storage,
    private emailComposer: EmailComposer,
    private formBuilder: FormBuilder,
    private firebaseAnalytics: FirebaseAnalytics
    ) {
      this.firebaseAnalytics.logEvent;
      this.firebaseAnalytics.setCurrentScreen("Solicitar Vacante");
    }

  get nombre() {
    return this.reparacionForm.get('nombre');
  }
  get apellido() {
    return this.reparacionForm.get('apellido');
  }
  get cargo() {
    return this.reparacionForm.get('cargo');
  }
  get empresa() {
    return this.reparacionForm.get('empresa');
  }
  get telefono() {
    return this.reparacionForm.get('telefono');
  }
  get oficina() {
    return this.reparacionForm.get('oficina');
  }
  get email() {
    return this.reparacionForm.get('email');
  }
  get mensaje() {
    return this.reparacionForm.get('mensaje');
  }

  // tslint:disable-next-line: member-ordering
  public errorMessages = {
    nombre: [
      { type: 'required', message: '* Requerido.' },
      { type: 'maxlength', message: '* Máximo 100 caracteres.' }
    ],
    apellido: [
      { type: 'required', message: '* Requerido.' },
      { type: 'maxlength', message: '* Máximo 100 caracteres.' }
    ],
    cargo: [
      { type: 'required', message: '* Requerido.' },
      { type: 'maxlength', message: '* Máximo 100 caracteres.' }
    ],
    empresa: [
      { type: 'required', message: '* Requerido.' },
      { type: 'maxlength', message: '* Máximo 100 caracteres.' }
    ],
    telefono: [
      { type: 'required', message: '* Requerido.' },
      { type: 'maxlength', message: '* Máximo 100 caracteres.' }
    ],
    oficina: [
      { type: 'required', message: '* Requerido.' },
      { type: 'maxlength', message: '* Máximo 100 caracteres.' }
    ],
    email: [
      { type: 'required', message: '* Requerido' },
      { type: 'pattern', message: '* Ingresa un E-mail válido' }
    ],
    mensaje: [
      { type: 'required', message: '* Requerido.' },
      { type: 'maxlength', message: '* Máximo 100 caracteres.' }
    ]
  };


  ngOnInit() {
    this.bringUser();
    this.reparacionForm = this.formBuilder.group({
      nombre: ['', [Validators.required, Validators.maxLength(100)]],
      apellido: ['', [Validators.required, Validators.maxLength(100)]],
      cargo: ['', [Validators.required, Validators.maxLength(100)]],
      empresa: ['', [ Validators.maxLength(100)]],
      telefono: ['', [Validators.required, Validators.maxLength(100)]],
      oficina: ['', [Validators.required, Validators.maxLength(100)]],
      email: ['',
        [
          Validators.pattern('^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')
        ]
      ],
      mensaje: ['', [Validators.maxLength(100)]]
    });
  }


  bringUser(){
    this.services.homeUser().subscribe(data => {
        console.log(data);
        this.reparacionForm.get('nombre').setValue(data["name"]);
        this.reparacionForm.get('apellido').setValue(data["lastName"] + ' ' + data["secondLastName"]);
        this.reparacionForm.get('email').setValue( data["email"]);
      },
      error => {
        console.log(error);
      },
    );
  }

  public submit() {
    const apps = 'correo';
    //NO INDENTAR ESTO, HACERLO AFECTA EL FORMATO DEL CUERPO
    const cuerpo = `Gracias por elegirnos como tus aliados en el proceso de reclutamiento de tu empresa, será un gusto apoyarte y ofrecerte todo nuestro portafolio de servicios; déjanos tus datos y en breve nuestro equipo de Atracción de Talento se acercará contigo.

Nombre: ${ this.reparacionForm.get('nombre').value }
Apellido: ${this.reparacionForm.get('apellido').value}
Cargo o puesto: ${this.reparacionForm.get('cargo').value}
Empresa: ${this.reparacionForm.get('empresa').value}
Celular: ${this.reparacionForm.get('telefono').value}
Número de oficina: ${this.reparacionForm.get('oficina').value}
E-mail: ${this.reparacionForm.get('email').value}

${this.reparacionForm.get('mensaje').value}

¡Porque hacer comunidad nos hace fuertes!`;

    const email = {
      to: 'rh_comuncnc@grupohitec.com',
      cc: [],
      attachments: [],
      subject: 'PUBLICACION DE VACANTE COMUNIDAD CNC',
      body: cuerpo,
      isHtml: false,
      app: apps
    };
    this.emailComposer.open(email);

    


    /*setTimeout(() => { alert(`Apreciado Cliente 

Hemos recibido de manera exitosa la solicitud de contratar uno de los servicios por parte del equipo de Recursos Humanos de Grupo Hitec.
  
Conocemos la importancia de su requerimiento, por ello, en breve uno de nuestros colaboradores se pondrá en contacto con usted con la finalidad de darle el seguimiento oportuno. 

Gracias`) }, 4000);*/
  }
}
